<div class="filter-container d-flex">
	<!-- period filter -->
	<div class="col-sm-6 col-md-3 col-lg-3">
		<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
		<ng-select
			class="select"
			[items]="periods"
			[addTag]="false"
			[clearable]="false"
			[searchable]="false"
			bindLabel="label"
			bindValue="value"
			(change)="onSelectionChanged({filter: 'period', value: $event.value})"
			[placeholder]="'g.durations' | translate"
			[(ngModel)]="selectedPeriod"
		></ng-select>
	</div>
	<!-- days filter -->
	<div class="col-sm-6 col-md-3 col-lg-3">
		<label for="workingDaysSelect">{{"operation_analysis.working_days" | translate}}</label>
		<ng-select
			class="select"
			[items]="daysFilters"
			[addTag]="false"
			[clearable]="false"
			[searchable]="false"
			bindLabel="label"
			bindValue="value"
			(change)="onSelectionChanged({filter: 'daysFilter', value: $event.value})"
			[placeholder]="'g.durations' | translate"
			[(ngModel)]="selectedDays"
		></ng-select>
	</div>
</div>


